import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import ReviewSubmitContent from 'components/review-submit/ReviewSubmitContent';
import { PageWrapperStyled } from '../../globalStyles';

const ReviewSubmitPage: React.FC = () => {
  return (
    <ProposalStatusLayout>
      <PageWrapperStyled>
        <ReviewSubmitContent />
      </PageWrapperStyled>
    </ProposalStatusLayout>
  );
};

export default ReviewSubmitPage;
